import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["content"]
  static values = {
    url: String
  }

  connect() {
    // Add event listener for escape key
    document.addEventListener('keyup', this.handleKeyup.bind(this))
  }

  disconnect() {
    document.removeEventListener('keyup', this.handleKeyup.bind(this))
    this.close()
  }

  async open(event) {
    // Rule applied: Use Hotwire (Turbo and Stimulus) for dynamic, SPA-like interactions
    
    // Check if we have a target modal ID
    const targetModalId = event.currentTarget.dataset.modalTarget
    
    if (targetModalId) {
      // Find the target modal by ID
      const targetModal = document.getElementById(targetModalId)
      if (targetModal) {
        // Show the target modal
        targetModal.classList.remove('hidden')
        // Prevent body scrolling
        document.body.classList.add('overflow-hidden')
        return
      }
    }
    
    // Get the URL from the button that triggered the modal
    const url = event.currentTarget.dataset.modalUrl || this.urlValue

    // If we have a URL, fetch the content
    if (url) {
      try {
        const response = await fetch(url, {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
            'Turbo-Frame': 'false'
          }
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const html = await response.text()
        const contentDiv = this.element.querySelector('.modal-content')
        if (contentDiv) {
          contentDiv.innerHTML = html
        }

        // Show modal
        this.element.classList.remove('hidden')
        // Prevent body scrolling
        document.body.classList.add('overflow-hidden')
      } catch (error) {
        console.error('Error loading modal content:', error)
      }
    }
  }

  close(event) {
    // Rule applied: Use Hotwire (Turbo and Stimulus) for dynamic, SPA-like interactions
    
    // If event is provided, prevent default
    if (event) {
      event.preventDefault()
    }
    
    // If this is called from a button inside a modal
    if (event && event.currentTarget.closest('[data-modal-target="modal"]')) {
      // Close the parent modal
      const modal = event.currentTarget.closest('[data-modal-target="modal"]')
      modal.classList.add('hidden')
    } else {
      // Close this modal
      this.element.classList.add('hidden')
    }
    
    // Re-enable body scrolling
    document.body.classList.remove('overflow-hidden')
    // Clear content
    const contentDiv = this.element.querySelector('.modal-content')
    if (contentDiv) {
      contentDiv.innerHTML = ''
    }
  }

  handleKeyup(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  // Handle form submission success
  success() {
    // Close the modal
    this.close()
    
    // Reload the page to show updated data
    window.location.reload()
  }
  
  // Open the payment modal with specific payment data
  openPaymentModal(event) {
    // Get payment data from the button
    const button = event.currentTarget
    const paymentId = button.dataset.paymentId
    const paymentAmount = button.dataset.paymentAmount
    
    // Set the values in the form
    const modal = document.getElementById('staff-payment-modal')
    const paymentIdField = document.getElementById('payment-id-field')
    const paymentAmountDisplay = document.getElementById('payment-amount-display')
    
    if (paymentIdField && paymentAmountDisplay) {
      paymentIdField.value = paymentId
      paymentAmountDisplay.textContent = paymentAmount
    }
    
    // Show the modal
    if (modal) {
      modal.classList.remove('hidden')
      // Prevent body scrolling
      document.body.classList.add('overflow-hidden')
    }
  }
  
  // Toggle card fields based on payment method selection
  toggleCardFields(event) {
    const paymentMethod = event.target.value
    const cardFields = document.getElementById('card-fields')
    
    if (cardFields) {
      if (paymentMethod === 'credit_card') {
        cardFields.classList.remove('hidden')
      } else {
        cardFields.classList.add('hidden')
      }
    }
  }
  
  // Submit form and close modal
  submitAndClose(event) {
    const paymentMethod = document.querySelector('input[name="payment_method"]:checked')
    
    // If payment method is not credit card, or if credit card fields are already processed,
    // allow the form to submit normally
    if (!paymentMethod || paymentMethod.value !== 'credit_card' || event.target.querySelector('input[name="card_token"]')) {
      // Form will submit normally
      setTimeout(() => {
        this.close()
      }, 100)
    }
    // Otherwise, the credit card processing is handled by the Stripe event listener
  }
}
